"use client";
import { memo, useState, useRef } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";
import { FaPlay } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "next-i18next";
// api
import { getCloudfrontUrl } from "../../utils/mediaHelper";
import Link from "next/link";

const IndustryTestimonials = memo(({ testimonials, className = "" }) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const lang = router.locale || "en";
  const [isOpen, setOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const extractYouTubeID = (url) => {
    const regex =
      /(?:youtube\.com\/(?:shorts\/|[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const openVideoModal = (videoUrl) => {
    // setVideoId(videoUrl);
    // setOpen(true);
    const id = extractYouTubeID(videoUrl);
    if (id) {
      setVideoId(id);
      setOpen(true);
    }
  };

  return (
    <div className="w-full bg-text-primary text-background-color-primary">
      <div
        className={`w-full box-border px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] py-[40px] md:py-[40px] lg:py-[60px] lg:py-[60px] max-w-[1600px] mx-auto ${className}`}
      >
        {/* Header */}
        <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-6 md:mb-10">
          <h2 className="text-[28px] sm:text-[32px] lg:text-[40px] font-medium leading-[120%] m-0">
            {t("testimonials.title")}
          </h2>
          <Link
            className="no-underline rounded-[50px] bg-crimson text-white text-[16px] font-medium py-3 px-6 cursor-pointer hover:bg-[#e72c46] transition duration-300 ease-in-out"
            href="/digital-marketing-reviews"
          >
            {t("testimonials.btnTxt")}
          </Link>
        </div>

        {/* Carousel */}

        <Swiper
          dir={lang === "ar" && "ltr"}
          modules={[Navigation, Autoplay]}
          spaceBetween={40}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            if (typeof swiper.params.navigation !== "boolean") {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }
          }}
          // autoplay={{ delay: 5000 }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
            1280: { slidesPerView: 2 },
          }}
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial?._id}>
              <div
                onClick={() => openVideoModal(testimonial?.youtubeUrl)}
                // className="rounded-2xl overflow-hidden border border-gray-300 border-solid p-3 bg-black"
              >
                <div className="relative w-full max-w-[640px] rounded-[24px] overflow-hidden">
                  <Image
                    src={getCloudfrontUrl(testimonial?.thumbnailUrl)}
                    alt={testimonial?.altText || "Testimonial Thumbnail"}
                    width={640}
                    height={200}
                    className="w-full h-auto object-contain"
                  />
                  {testimonial?.youtubeUrl && (
                    <div className="absolute inset-0 flex items-center justify-center ">
                      <div className="bg-black/60 rounded-full flex items-center justify-center cursor-pointer">
                        <FaPlay className="text-white text-[50px] p-3" />
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className="py-4 text-white text-[16px]">
                  <p className="mb-2">
                    “Horem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis.”
                  </p>
                  <p className="font-medium m-0">{testimonial?.name}</p>
                </div> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex gap-3 md:hidden mt-5 justify-center">
          <button
            ref={prevRef}
            className="w-[44px] h-[44px] border border-white rounded-full flex items-center justify-center text-white bg-transparent hover:bg-white hover:text-black transition"
          >
            <IoIosArrowBack size={20} />
          </button>
          <button
            ref={nextRef}
            className="w-[44px] h-[44px] border border-white rounded-full flex items-center justify-center text-white bg-transparent hover:bg-white hover:text-black transition"
          >
            <IoIosArrowForward size={20} />
          </button>
        </div>

        {/* YouTube Modal */}
        <ModalVideo
          channel="youtube"
          videoId={videoId}
          // channel="custom"
          // url={videoId}
          isOpen={isOpen}
          onClose={() => setOpen(false)}
        />
      </div>
    </div>
  );
});

IndustryTestimonials.propTypes = {
  className: PropTypes.string,
};

export default IndustryTestimonials;
